export default __webpack_public_path__ + "8071125b0a3b0e41602a11bdde60a04c.jpeg";